import { useTheme } from "@emotion/react";
import React, { useMemo } from "react";

import { Priority } from "@megaron/support-contracts";

import { SupportSelect, SupportSelectDot, SupportSelectOption } from "./SupportSelect";

type Props = {
  value: Priority | null | undefined;
  isDisabled?: boolean;
  onChange: (priority: Priority | null) => void;
};

const priorityLabels: Record<Priority, string> = {
  low: "Niski",
  medium: "Średni",
  high: "Wysoki",
  urgent: "Pilny",
};

const priorityOrder: (Priority | null)[] = [null, "low", "medium", "high", "urgent"];

const priorityColor = (
  priority: Priority | null,
  colors: { success: string; warning: string; danger: string; primary: string; secondaryText: string },
) => {
  if (priority === "low") return colors.success;
  if (priority === "medium") return colors.warning;
  if (priority === "high") return colors.danger;
  if (priority === "urgent") return colors.primary;
  return colors.secondaryText;
};

export const SupportPrioritySelect: React.FC<Props> = ({ value, onChange, isDisabled }) => {
  const theme = useTheme();

  const options = useMemo<SupportSelectOption<Priority>[]>(
    () =>
      priorityOrder.map((priority) => {
        const color = priorityColor(priority, theme.colors);
        return {
          value: priority,
          label: priority ? priorityLabels[priority] : "Ustaw priorytet",
          color,
          icon: <SupportSelectDot color={color} />,
        };
      }),
    [theme.colors],
  );

  return <SupportSelect<Priority> value={value} options={options} onChange={onChange} isDisabled={isDisabled} />;
};
